'use client'

import { useEffect } from 'react'

import { DigitalProductPassportItemDto } from '@marketplace-web/pro-integrations/pro-integrations-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { Screen } from 'constants/tracking/screens'

import HeaderSection from './HeaderSection'
import HowItWorksSection from './HowItWorksSection'
import PreviewSection from './PreviewSection'
import SellSection from './SellSection'

const VIEW_EVENT = 'dpp_user_view_screen'

const DigitalProductPassport = ({
  dppRef,
  dppItem,
}: {
  dppRef: string
  dppItem: DigitalProductPassportItemDto
}) => {
  const { track } = useTracking()

  useEffect(() => {
    track({
      event: VIEW_EVENT,
      extra: {
        screen: Screen.DigitalProductPassport,
        target: 'digital_product_passport',
        target_details: dppRef,
      },
    })
  }, [track, dppRef])

  return (
    <>
      <HeaderSection dppItem={dppItem} />
      <PreviewSection dppRef={dppRef} dppItem={dppItem} />
      <HowItWorksSection />
      <SellSection dppRef={dppRef} />
    </>
  )
}

export default DigitalProductPassport
